const AllServicesData = 
    {
  links: {
    next: "",
    previous: ""
  },
  results: [
  {
    s_id: 'SERV001',
    status: 'active',
    name: 'Professional Cleaning Service',
    category_p: 'Home Services',
    s_hsn_code_no: '9954',
    is_verified: true,
    s_add_by: 'admin1',
    s_add_date: '2023-05-15',
    s_add_time: '10:30:00',
    s_last_modified_by: 'admin2',
    s_last_add_date: '2023-06-20',
    s_last_add_time: '14:45:00',
    s_owner: 'CleanCo',
    s_recommended_for: 'Residential properties',
    tag: 'cleaning, home',
    next_step: 'Schedule appointment',
    default_unit: 'per hour',
    indicative_min_price: 500,
    indicative_max_price: 1500,
    s_price: 1200,
    s_old_price: 1500,
    s_discount: 20,
    production_capacity: 10,
    production_capacity_unit: 'jobs per day',
    present_stock_status: 'Available',
    production_lead_time: '2 hours',
    min_order_quantity: 1,
    min_order_quantity_unit: 'job',
    s_life: 'Ongoing',
    s_lifespan: 'N/A',
    s_certification: 'ISO 9001',
    s_description: 'Professional deep cleaning for homes and apartments',
    s_varient: 'Standard, Deep, Premium'
  },
  {
    s_id: 'SERV002',
    status: 'active',
    name: 'AC Repair & Maintenance',
    category_p: 'Appliance Services',
    s_hsn_code_no: '9954',
    is_verified: true,
    s_add_by: 'admin1',
    s_add_date: '2023-04-10',
    s_add_time: '11:15:00',
    s_last_modified_by: 'admin1',
    s_last_add_date: '2023-04-15',
    s_last_add_time: '16:20:00',
    s_owner: 'CoolAir',
    s_recommended_for: 'Home/Office AC units',
    tag: 'repair, maintenance',
    next_step: 'Diagnose issue',
    default_unit: 'per service',
    indicative_min_price: 800,
    indicative_max_price: 3000,
    s_price: 2500,
    s_old_price: 3000,
    s_discount: 16.67,
    production_capacity: 15,
    production_capacity_unit: 'units per day',
    present_stock_status: 'Available',
    production_lead_time: '24 hours',
    min_order_quantity: 1,
    min_order_quantity_unit: 'unit',
    s_life: 'Ongoing',
    s_lifespan: 'N/A',
    s_certification: 'ISO 14001',
    s_description: 'Comprehensive AC repair and annual maintenance contracts',
    s_varient: 'Basic, Comprehensive'
  },
  {
    s_id: 'SERV003',
    status: 'active',
    name: 'Graphic Design Package',
    category_p: 'Creative Services',
    s_hsn_code_no: '9983',
    is_verified: true,
    s_add_by: 'admin3',
    s_add_date: '2023-07-01',
    s_add_time: '09:00:00',
    s_last_modified_by: 'admin3',
    s_last_add_date: '2023-07-10',
    s_last_add_time: '11:30:00',
    s_owner: 'DesignHub',
    s_recommended_for: 'Small businesses',
    tag: 'design, branding',
    next_step: 'Consultation',
    default_unit: 'per project',
    indicative_min_price: 5000,
    indicative_max_price: 20000,
    s_price: 15000,
    s_old_price: 18000,
    s_discount: 16.67,
    production_capacity: 5,
    production_capacity_unit: 'projects per week',
    present_stock_status: 'Available',
    production_lead_time: '7 days',
    min_order_quantity: 1,
    min_order_quantity_unit: 'project',
    s_life: 'One-time',
    s_lifespan: 'N/A',
    s_certification: '',
    s_description: 'Complete branding package including logo, business cards and social media kit',
    s_varient: 'Basic, Premium, Deluxe'
  },
  {
    s_id: 'SERV004',
    status: 'inactive',
    name: 'Tax Consultation',
    category_p: 'Financial Services',
    s_hsn_code_no: '9983',
    is_verified: false,
    s_add_by: 'admin2',
    s_add_date: '2023-02-15',
    s_add_time: '14:00:00',
    s_last_modified_by: 'admin1',
    s_last_add_date: '2023-03-01',
    s_last_add_time: '10:00:00',
    s_owner: 'TaxExperts',
    s_recommended_for: 'Individuals and businesses',
    tag: 'tax, finance',
    next_step: 'Document collection',
    default_unit: 'per hour',
    indicative_min_price: 2000,
    indicative_max_price: 5000,
    s_price: 3500,
    s_old_price: 4000,
    s_discount: 12.5,
    production_capacity: 8,
    production_capacity_unit: 'clients per day',
    present_stock_status: 'Limited',
    production_lead_time: '3 days',
    min_order_quantity: 1,
    min_order_quantity_unit: 'session',
    s_life: 'Annual',
    s_lifespan: '1 year',
    s_certification: 'CPA Certified',
    s_description: 'Professional tax consultation and filing services',
    s_varient: 'Individual, Business'
  },
  {
    s_id: 'SERV005',
    status: 'active',
    name: 'Website Development',
    category_p: 'IT Services',
    s_hsn_code_no: '9983',
    is_verified: true,
    s_add_by: 'admin4',
    s_add_date: '2023-01-05',
    s_add_time: '13:20:00',
    s_last_modified_by: 'admin4',
    s_last_add_date: '2023-08-15',
    s_last_add_time: '15:10:00',
    s_owner: 'WebCraft',
    s_recommended_for: 'Startups and SMEs',
    tag: 'web, development',
    next_step: 'Requirement analysis',
    default_unit: 'per project',
    indicative_min_price: 15000,
    indicative_max_price: 100000,
    s_price: 50000,
    s_old_price: 60000,
    s_discount: 16.67,
    production_capacity: 3,
    production_capacity_unit: 'projects per month',
    present_stock_status: 'Available',
    production_lead_time: '30 days',
    min_order_quantity: 1,
    min_order_quantity_unit: 'project',
    s_life: 'One-time',
    s_lifespan: 'N/A',
    s_certification: '',
    s_description: 'Custom website development with responsive design',
    s_varient: 'Basic, CMS, E-commerce'
  },
  {
    s_id: 'SERV006',
    status: 'active',
    name: 'Interior Design Consultation',
    category_p: 'Home Services',
    s_hsn_code_no: '9954',
    is_verified: true,
    s_add_by: 'admin2',
    s_add_date: '2023-03-12',
    s_add_time: '10:45:00',
    s_last_modified_by: 'admin2',
    s_last_add_date: '2023-05-18',
    s_last_add_time: '12:30:00',
    s_owner: 'DesignLiving',
    s_recommended_for: 'Homeowners',
    tag: 'interior, design',
    next_step: 'Site visit',
    default_unit: 'per session',
    indicative_min_price: 3000,
    indicative_max_price: 10000,
    s_price: 7000,
    s_old_price: 8000,
    s_discount: 12.5,
    production_capacity: 4,
    production_capacity_unit: 'sessions per day',
    present_stock_status: 'Available',
    production_lead_time: '7 days',
    min_order_quantity: 1,
    min_order_quantity_unit: 'session',
    s_life: 'One-time',
    s_lifespan: 'N/A',
    s_certification: 'CIDA Certified',
    s_description: 'Professional interior design consultation with 3D visualization',
    s_varient: 'Basic, Premium'
  },
  {
    s_id: 'SERV007',
    status: 'active',
    name: 'Corporate Catering',
    category_p: 'Food Services',
    s_hsn_code_no: '9963',
    is_verified: true,
    s_add_by: 'admin5',
    s_add_date: '2023-06-01',
    s_add_time: '09:15:00',
    s_last_modified_by: 'admin5',
    s_last_add_date: '2023-07-22',
    s_last_add_time: '11:45:00',
    s_owner: 'FoodExpress',
    s_recommended_for: 'Corporate events',
    tag: 'catering, food',
    next_step: 'Menu selection',
    default_unit: 'per person',
    indicative_min_price: 300,
    indicative_max_price: 1500,
    s_price: 800,
    s_old_price: 1000,
    s_discount: 20,
    production_capacity: 200,
    production_capacity_unit: 'meals per day',
    present_stock_status: 'Available',
    production_lead_time: '3 days',
    min_order_quantity: 20,
    min_order_quantity_unit: 'persons',
    s_life: 'One-time',
    s_lifespan: 'N/A',
    s_certification: 'FSSAI Certified',
    s_description: 'Premium catering service for corporate meetings and events',
    s_varient: 'Vegetarian, Non-vegetarian, Jain'
  },
  {
    s_id: 'SERV008',
    status: 'inactive',
    name: 'Personal Fitness Training',
    category_p: 'Health Services',
    s_hsn_code_no: '9993',
    is_verified: false,
    s_add_by: 'admin3',
    s_add_date: '2023-02-28',
    s_add_time: '16:30:00',
    s_last_modified_by: 'admin3',
    s_last_add_date: '2023-04-15',
    s_last_add_time: '10:20:00',
    s_owner: 'FitLife',
    s_recommended_for: 'Individuals',
    tag: 'fitness, health',
    next_step: 'Fitness assessment',
    default_unit: 'per session',
    indicative_min_price: 500,
    indicative_max_price: 2000,
    s_price: 1500,
    s_old_price: 1800,
    s_discount: 16.67,
    production_capacity: 8,
    production_capacity_unit: 'sessions per day',
    present_stock_status: 'Unavailable',
    production_lead_time: '1 day',
    min_order_quantity: 1,
    min_order_quantity_unit: 'session',
    s_life: 'Monthly',
    s_lifespan: '1 month',
    s_certification: 'ACE Certified',
    s_description: 'Personalized fitness training with certified trainers',
    s_varient: 'Gym, Home, Online'
  },
  {
    s_id: 'SERV009',
    status: 'active',
    name: 'Mobile App Development',
    category_p: 'IT Services',
    s_hsn_code_no: '9983',
    is_verified: true,
    s_add_by: 'admin4',
    s_add_date: '2023-05-10',
    s_add_time: '14:00:00',
    s_last_modified_by: 'admin4',
    s_last_add_date: '2023-08-01',
    s_last_add_time: '16:45:00',
    s_owner: 'AppMasters',
    s_recommended_for: 'Businesses',
    tag: 'mobile, app',
    next_step: 'Requirement gathering',
    default_unit: 'per project',
    indicative_min_price: 50000,
    indicative_max_price: 500000,
    s_price: 200000,
    s_old_price: 250000,
    s_discount: 20,
    production_capacity: 2,
    production_capacity_unit: 'projects per month',
    present_stock_status: 'Available',
    production_lead_time: '60 days',
    min_order_quantity: 1,
    min_order_quantity_unit: 'project',
    s_life: 'One-time',
    s_lifespan: 'N/A',
    s_certification: '',
    s_description: 'Custom mobile application development for iOS and Android',
    s_varient: 'Basic, Enterprise'
  },
  {
    s_id: 'SERV010',
    status: 'active',
    name: 'Legal Consultation',
    category_p: 'Professional Services',
    s_hsn_code_no: '9983',
    is_verified: true,
    s_add_by: 'admin1',
    s_add_date: '2023-01-15',
    s_add_time: '11:00:00',
    s_last_modified_by: 'admin1',
    s_last_add_date: '2023-06-10',
    s_last_add_time: '14:30:00',
    s_owner: 'LawAssociates',
    s_recommended_for: 'Individuals and businesses',
    tag: 'legal, consultation',
    next_step: 'Document review',
    default_unit: 'per hour',
    indicative_min_price: 3000,
    indicative_max_price: 10000,
    s_price: 6000,
    s_old_price: 7500,
    s_discount: 20,
    production_capacity: 6,
    production_capacity_unit: 'clients per day',
    present_stock_status: 'Available',
    production_lead_time: '2 days',
    min_order_quantity: 1,
    min_order_quantity_unit: 'hour',
    s_life: 'Ongoing',
    s_lifespan: 'N/A',
    s_certification: 'Bar Council Certified',
    s_description: 'Professional legal consultation for various matters',
    s_varient: 'Civil, Criminal, Corporate'
  }
 ]
};


export default AllServicesData;